import React, { useState, useEffect } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { api } from '../api/api'

const ProtectedRoute = () => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(false);
    const [admin, setAdmin] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const checkAuthentication = async () => {
            try {
                // Check if it's an admin route
                if (location.pathname.startsWith('/admin')) {
                    const adminResponse = await api.get("/users/checkAdminLogin", { withCredentials: true });
                    setAdmin(!!adminResponse);
                    setLoading(false);
                } else {
                    // Check regular user authentication
                    const userResponse = await api.get("/users/checklogin", { withCredentials: true });
                    setUser(!!userResponse);
                    setLoading(false);
                }
            } catch (error) {
                // A 401 simply means the visitor is not logged in — that's expected,
                // so don't treat it as an error in the console.
                if (error?.response?.status !== 401) {
                    console.error('Authentication check failed:', error);
                }
                setUser(false);
                setAdmin(false);
                setLoading(false);
            }
        };

        checkAuthentication();
    }, [location.pathname]);
    
    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin">
                    <style>
                        {`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}
                    </style>
                </div>
            </div>
        );
    }

    // Check if it's an admin route
    // `replace` avoids pushing the protected URL onto history, which would
    // otherwise create a redirect loop when the user presses Back.
    if (location.pathname.startsWith('/admin')) {
        return admin ? <Outlet /> : <Navigate to="/" replace />;
    }

    // For all other routes, check regular user authentication
    return user ? <Outlet /> : <Navigate to="/signIn" replace />;
}

export default ProtectedRoute